module.exports = __webpack_public_path__ + "img/VIP.1415ea78.gif";